export const ADMIN_LOCALS = '15sdf#4%$#sd#@_)54'
export const LIGUE_LOCALS = 'pk((^%*kj$%&hg81+_)(&'
export const DATE_VALIDATOR_LOCALS = 'Vous devez avoir entre 10 et 99 ans'